import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClubComponent } from './club/club.component';
import { GroundRegulationsComponent } from './ground-regulations/ground-regulations.component';
import { AccessStatementComponent } from './access-statement/access-statement.component';
import { RecruitmentComponent } from './recruitment/recruitment.component';
import { GovernanceComponent } from './governance/governance.component';
import { ContactComponent } from './contact/contact.component';
const routes: Routes = [
  //{path: "club", component: ClubComponent},
  {path: "club/premier-outdoor-venue", component: ClubComponent},
  {path: "club/directions", component: ClubComponent},
  {path: "club/ground-regulations", component: ClubComponent},
  {path: "club/access-statement", component: ClubComponent},
  {path: "club/about", component: GroundRegulationsComponent},
  {path: "club/history", component: GroundRegulationsComponent},
  {path: "club/meet-the-board", component: GroundRegulationsComponent},
  {path: "club/friends-of-grace-road", component: GroundRegulationsComponent},
  {path: "club/leicestershire-cricket-society", component: GroundRegulationsComponent},
  {path: "club/governance", component: GroundRegulationsComponent},
  {path: "club/honours", component: GroundRegulationsComponent},
      {path: "club/museum", component: GroundRegulationsComponent},
  {path: "club/safeguarding", component: GroundRegulationsComponent},
  {path: "ground-regulations", component: GroundRegulationsComponent},
  {path: "access-statement", component: AccessStatementComponent},
  {path: "recruitment", component: RecruitmentComponent},
  {path: "governance", component: GovernanceComponent},
  {path: "contact", component: ContactComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClubRoutingModule { }
